import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { TransporterConfigurationEnum } from '../../../../models/enums/configuration.enum';
import { TransporterConfigurationService } from '../../../../services/transporter-configuration.service';
import { OfferEstimation } from '../../../../models/offer-estimation.model';
import { OfferType } from '../../../../models/enums/offer-type.enum';

@Component({
  selector: 'jhi-bary-pricing-pack',
  templateUrl: './bary-pricing-pack.component.html',
  styleUrls: ['./bary-pricing-pack.component.scss'],
})
export class BaryPricingPackComponent implements OnInit {
  readonly #transporterConfigurationService = inject(TransporterConfigurationService);

  @Input() offerEstimation!: OfferEstimation;
  @Input() isSelectedOffer = false;

  @Output() estimateEvent = new EventEmitter<any>();

  public hasFlexibleConfig: boolean = false;

  public ngOnInit() {
    this.#transporterConfigurationService
      .getBooleanConfiguration(TransporterConfigurationEnum.ACTIVATION_FLEXIBILITY_DEADLINE)
      .subscribe(val => (this.hasFlexibleConfig = val as boolean));
  }

  public handleEstimate(): void {
    this.estimateEvent.emit(this.offerEstimation);
  }

  public selectButtonLabel(): string {
    return this.offerEstimation.type === OfferType.QUOTATION ? 'BARY_LIGHT_ESTIMATE.BTN.ASK_QUOTATION' : 'BARY_LIGHT_ESTIMATE.BTN.SELECTED_OFFER';
  }
}
